import React, { Component } from 'react';

import TicketBox from './TicketBox';
import TicketBoxStyle from './TicketBoxStyle';
import IconTicket from '../../assets/icons/IconTicket';
import IconTicketChecked from '../../assets/icons/IconTicketChecked';
import IconTicketLoading from '../../assets/icons/IconTicketLoading';
import IconTicketTotalPoint from '../../assets/icons/IconTicketTotalPoint';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';

class TicketBoxListSolutionCSO extends Component {
    filterStatus = status => {
        const filtered = this.props.data.filter((ticket) => ticket.status === status);
        return filtered.length;
    };

    filterDataTracker = status => {
        if (status === 'all') {
            const filtered = this.props.data;
            return {
                whatsapp: filtered.filter((ticket) => ticket.tracker === 'chat').length,
                phone: filtered.filter((ticket) => ticket.tracker === 'phone').length,
                email: filtered.filter((ticket) => ticket.tracker === 'email').length,
                grochat: filtered.filter((ticket) => ticket.tracker === 'grochat').length,
                status
            };
        }

        const filtered = this.props.data.filter((ticket) => ticket.status === status);
        return filtered.sort((a, b) => b.ticket_no.localeCompare(a.ticket_no));
    }

    render() {
        return (
            <>
                {/* Dashboard Ticket box 2nd Row */}
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnresolved" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.RESOLVED))} titleTicket="resolved" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.RESOLVED)} iconTicket={<IconTicketChecked />} textColor="text-nexcaregreen1" iconBoxColor="bg-nexcaregreen1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnclosed" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.CLOSED))} titleTicket="closed" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.CLOSED)} iconTicket={<IconTicketChecked />} textColor="text-nexcaresalmon1" iconBoxColor="bg-nexcaresalmon1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btnunderobservation" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker(STATUS_TICKET_CONSTANT.UNDER_OBSERVATION))} titleTicket="under observation" totalTicket={this.filterStatus(STATUS_TICKET_CONSTANT.UNDER_OBSERVATION)} iconTicket={<IconTicketLoading />} textColor="text-nexcarepurple1" iconBoxColor="bg-nexcarepurple1" />
                </div>
                <div className="ticket-box-container">
                    <TicketBox loading={this.props.loading} id="btntotalticket" handlePopup={e => this.props.handlePopupTicketBox(e, this.filterDataTracker('all'))} titleTicket="total tiket diterima" totalTicket={this.props.data.length} iconTicket={<IconTicket />} textColor="text-nexcareblue3" iconBoxColor="bg-nexcareblue3" />
                </div>
                <div>
                    {/* Blank Div for Grid */}
                </div>
                <div className="rounded-md shadow-lg h-32 bg-white relative col-span-2">
                    <TicketBoxStyle
                        loading={this.props.loading}
                        textColor="text-blue-800"
                        iconTitle={<IconTicketTotalPoint />}
                        titleTicket="total poin"
                        totalTicket={this.props.commissionData.total_point ? this.props.commissionData.total_point : '0'}
                        boxIconColor="#D9D9D9"
                    />
                </div>
            </>
        );
    }
}

export default TicketBoxListSolutionCSO;